import * as React from 'react';

function DescriptionIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20px"
      height="18px"
      viewBox="0 0 20 18"
    >
      <image
        id="image0"
        width="20"
        height="18"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAMAAABsDg4iAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAUVBMVEUAAAAAEEACEjYBEzcB
FDcDEzgAEDgCEzcCEjYCFDcBFDgCFDgAEDABEjcAEzgCEzc/LzFsQi58SiwRGja4ZSf1gCGpXig/
LjFtQy1tQy7///9bIds2AAAAD3RSTlMAEH+/z2Ag34DPv4AQ32Akw968AAAAAWJLR0QadWfkMgAA
AAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+YCEg8YAutQIAMAAAB6SURBVBjThdDbDsIgEEXR
U9uCt3pwuOn//6gdSQ2FJu6HeVgJmQkAhtPIX9MMzVi6p2w5WrOi9SFWJW8HzExxV+AZFxeb8ghK
iy9+MeiKUGaMUlD0GCmzQkAR+I8Hz/tF7/akFa/5AG8MPd4XnzqEWZilLlN/9DFx3wcikBfoqp3E
NwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wMi0xOFQxMjoyNDowMiswMzowMIszDs4AAAAldEVY
dGRhdGU6bW9kaWZ5ADIwMjItMDItMThUMTI6MjQ6MDIrMDM6MDD6brZyAAAAAElFTkSuQmCC"
      />
    </svg>
  );
}

export default DescriptionIcon;
